import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { AdsCreativeItem } from '@brand24-original/llm-types';
import { AdsFilters, getAdsCreatives } from '../../services/ads/AdsService';
import { GET_ADS_CREATIVES } from '../../query/ads/keys';

export const useGetAdsCreatives = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  filters: AdsFilters,
  enabled = true
) => {
  const queryEnabled = !!projectId && !!from && !!to && enabled;

  const { data, isLoading, isError, refetch } = useQuery<AdsCreativeItem[]>({
    queryKey: [GET_ADS_CREATIVES, projectId, from, to, filters.models, filters.promptIds, filters.advertisers],
    queryFn: () => getAdsCreatives(projectId!, from!, to!, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    placeholderData: keepPreviousData,
  });

  return {
    creatives: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
